module.exports = __webpack_public_path__ + "static/media/fishmorsel.cfd623e6.webp";